import React, { useEffect, useState } from 'react';
import { devApi } from '../../services/api';
import {
  PageTitle,
  PageDescription,
  Card,
  Table,
  ErrorMessage,
  LoadingMessage,
} from './styles';

export default function DevCoaches() {
  const [coaches, setCoaches] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    devApi
      .getCoaches()
      .then((res) => {
        if (!cancelled) {
          setCoaches(Array.isArray(res) ? res : []);
          setError(null);
        }
      })
      .catch((err: any) => {
        if (!cancelled) {
          setError(err?.response?.data?.message || err?.message || 'Failed to load coaches');
          setCoaches([]);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return <LoadingMessage>Loading coaches…</LoadingMessage>;
  }
  if (error) {
    return (
      <>
        <PageTitle>Coaches</PageTitle>
        <ErrorMessage>{error}</ErrorMessage>
      </>
    );
  }

  return (
    <>
      <PageTitle>Coaches</PageTitle>
      <PageDescription>Coaches and the athletes they manage.</PageDescription>
      <Card>
        <Table>
          <thead>
            <tr>
              <th>Coach</th>
              <th>Email</th>
              <th># Athletes</th>
              <th>Athletes</th>
            </tr>
          </thead>
          <tbody>
            {coaches.map((c) => (
              <tr key={c.id}>
                <td>
                  {c.firstName} {c.lastName}
                </td>
                <td>{c.email}</td>
                <td>{c.athleteCount ?? 0}</td>
                <td>
                  {(c.athletes || [])
                    .map((a: any) => `${a.firstName} ${a.lastName}`)
                    .join(', ') || '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </>
  );
}
